import { render, staticRenderFns } from "./Memories.vue?vue&type=template&id=09ce6973&lang=pug&"
import script from "./Memories.vue?vue&type=script&lang=js&"
export * from "./Memories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ce6973')) {
      api.createRecord('09ce6973', component.options)
    } else {
      api.reload('09ce6973', component.options)
    }
    module.hot.accept("./Memories.vue?vue&type=template&id=09ce6973&lang=pug&", function () {
      api.rerender('09ce6973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/Memories.vue"
export default component.exports